import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { VisitorReasonRequest } from "../shared/VisitorReasonRequest";
import { DataService_ReasonMaintenance } from "../shared/data.service";

@Component({
	selector: "app-ms-add-visitor-reason",
	templateUrl: "./ms-add-visitor-reason.component.html",
	styleUrls: ["./ms-add-visitor-reason.component.css"],
})
export class MsAddVisitorReasonComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private confirmationService: ConfirmationService, private visitorService: DataService_ReasonMaintenance) {}

	ngOnInit(): void {}

	/////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////
	VisitorReasonDesc: string = "";
	errorMessage: string = "";
	Processing: boolean = false;
	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		if (this.VisitorReasonDesc == undefined || this.VisitorReasonDesc.trim().length == 0) {
			this.errorMessage = "Enter reason description";
			return;
		}

		if (this.VisitorReasonDesc.length > 50) {
			this.errorMessage = "Reason description cannot be more than 50 characters. NOTE: Reasons show up as buttons in the app";
			return;
		}

		//
		// Check Name Already Used
		//
		this.Processing = true;

		var parms: VisitorReasonRequest = {
			VisitorReasonID: -1, //Adding new
			VisitorReasonDesc: this.VisitorReasonDesc,
		};

		var result = this.visitorService.VisitorReasonInUse(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.onFinishAdd(parms);
				} else {
					this.Processing = false;

					//Fail Dialog
					this.confirmationService.confirm({
						key: "confirmadd",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the visit reason: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onFinishAdd(parms: VisitorReasonRequest) {
		var result = this.visitorService.VisitorReasonInsert(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Visit Reason was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the visit reason: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////
	IsLoading() {
		return this.Processing == true;
	}
	/////////////////////////////////////////////////////////
}
